import React, { useState } from "react";
import styles from "./auth.module.css";
import { useFormik } from "formik";
import * as yup from "yup";
import InputCustom from "./InputCustom";
import axios from "axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from "react-router-dom";

const AuthPassword = () => {
  const history = useHistory();
  const location = useLocation();
  const [loader, setLoader] = useState(false);

  const initialValues = {
    password: "",
  };
  const onSubmit = (state) => {
    setLoader(true);
    const loginData = {
      phone: location.state.phone,
      password: state.password,
    };
    axios
      .post("https://arianaapp.arianaapply.com/panel/login", loginData)
      .then((res) => {
        setLoader(false);
        console.log(res.data);
        if (res.data.status !== 404) {
          localStorage.setItem("apDashboard", res.data.data.token);
          history.push("/");
          window.location.reload();

        } else {
          Swal.fire({
            title: "رمز عبور صحیح نمیباشد",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        setLoader(false);
        Swal.fire({
          title: "مشکلی پیش امده دوباره امتحان کنید",
          icon: "error",
        });
      });
  };

  const validationSchema = yup.object({
    password: yup.string().required("رمز عبور خود را وارد کنید"),
  });
  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <div className={styles.authPage}>
      <form className={styles.authForm} onSubmit={formik.handleSubmit}>
        <h4 className={styles.authTitle}>ورود به پنل آریانا پارس</h4>
        <InputCustom
          name="password"
          type="password"
          label="رمز عبور:"
          formikHandler={formik.getFieldProps("password")}
          formikErrors={formik.errors.password && formik.touched.password}
          formikErrorsName={formik.errors.password}
        />

        <button
          className={styles.submitButton}
          type="submit"
          disabled={!formik.isValid}
        >
          {loader ? <Spinner animation="border" variant="light" /> : "ورود"}
        </button>
        <span
          className={styles.authPush}
          onClick={() => history.push("/register")}
        >
          هنوز ثبت نام نکرده اید؟
        </span>
      </form>
    </div>
  );
};

export default AuthPassword;
